<script setup>
import { ref, onMounted } from 'vue'
import { useRequestsStore } from '@/stores/storeRequests'

const storeRequests = useRequestsStore()
const socialList = ref([])
const policy = ref(null)

onMounted(async () => {
	try {
		const socialRes = await storeRequests.getSocialNetworks()
		socialList.value = socialRes.filter((item) => !!item.url)

		const pdfRes = await storeRequests.getPdf()
		policy.value = pdfRes?.policy || null
	} catch (error) {
		console.error('Ошибка при загрузке данных футера:', error)
	}
})
</script>

<template>
	<footer>
		<div class="footer" id="contact">
			<div class="footer__container">
				<div class="footer__top">
					<ul class="footer__social">
						<li v-for="item in socialList" :key="item.id">
							<a :href="item.url" target="_blank" rel="noopener">
								<!-- предупреждение только у IG -->
								<span v-if="item.name === 'IG'" class="footer__warning">
									<svg
										width="17"
										height="17"
										viewBox="0 0 17 17"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M7.01095 17L7.25912 10.5069L1.48905 13.9896L0 11.5104L6.08029 8.5L0 5.48958L1.48905 3.01042L7.25912 6.49306L7.01095 0H9.98905L9.74088 6.49306L15.5109 3.01042L17 5.48958L10.9197 8.5L17 11.5104L15.5109 13.9896L9.74088 10.5069L9.98905 17H7.01095Z"
											fill="white"
										/>
									</svg>
								</span>

								<img :src="item.logo" :alt="item.name" />
							</a>
						</li>
					</ul>
					<div class="footer__hint">
						*Meta — запрещённая организация на территории РФ. Instagram и Facebook —
						проекты Meta Platforms Inc., деятельность которых на территории РФ
						запрещена.
					</div>

					<div class="footer__text">
						В наших соцсетях мы постоянно
						<span>
							разыгрываем маски и устраиваем различные конкурсы, игровые турниры
						</span>
						и многое другое среди подписчиков.
					</div>
				</div>

				<div class="footer__bottom">
					<ul>
						<li>© Все права защищены</li>
						<li>
							<a
								href="https://lucky-site.com/"
								rel="nofollow noopener"
								target="_blank"
							>
								Разработано в студии
								<img loading="lazy" src="@/assets/img/dev-logo.png" alt="" />
							</a>
						</li>
						<li v-if="policy">
							<a :href="policy">Обработка персональных данных</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</footer>
</template>

<style lang="scss" scoped>
.footer {
	padding: 13.2rem 0 0;

	@media (max-width: 991.98px) {
		padding-top: 4.1rem;
	}

	// .footer__container
	&__container {
	}

	// .footer__top
	&__top {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;
	}

	// .footer__social
	&__social {
		display: flex;
		align-items: center;
		gap: 2rem;
		justify-content: center;

		@media (max-width: 991.98px) {
			gap: 0.5rem;
		}

		li {
			a {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 20.2rem;
				height: 20.2rem;
				position: relative;

				@media (max-width: 991.98px) {
					width: 6rem;
					height: 6rem;
				}

				// &::after {
				// 	content: '';
				// 	position: absolute;
				// 	width: 135%;
				// 	height: 135%;
				// 	top: 50%;
				// 	left: 50%;
				// 	transform: translate(-50%, -50%);
				// 	background-image: url('@/assets/img/social-texture.png');
				// 	background-repeat: no-repeat;
				// 	background-position: center;
				// 	background-size: contain;
				// 	z-index: -1;
				// }

				span {
					position: absolute;
					bottom: calc(100% - 3rem);
					left: calc(100% - 3rem);

					svg {
						width: 1.7rem;
						height: 1.7rem;

						@media (max-width: 991.98px) {
							width: 0.6rem;
							height: 0.6rem;
						}
					}
				}

				svg {
					width: 100%;
					height: 100%;
				}
			}
		}
	}

	// .footer__hint
	&__hint {
		margin-top: 4.2rem;
		font-family: var(--second-font);
		font-weight: 600;
		font-size: 1.6rem;
		// line-height: 1.9rem;
		line-height: 116%;
		color: rgba(255, 255, 255, 0.7);
		max-width: 70.1rem;

		@media (max-width: 991.98px) {
			margin-top: 2rem;
			font-size: 1rem;
			line-height: 126%;
		}
	}

	// .footer__text
	&__text {
		font-family: var(--second-font);
		font-weight: 600;
		font-size: 3.2rem;
		// line-height: 4rem;
		line-height: 126%;
		max-width: 138rem;
		margin-top: 5rem;

		@media (max-width: 991.98px) {
			font-size: 1.8rem;
			margin-top: 2rem;
		}

		span {
			color: var(--primary-color);
		}
	}

	// .footer__bottom
	&__bottom {
		padding: 4rem 0;
		font-family: var(--second-font);
		font-weight: 400;
		font-size: 2.2rem;
		// line-height: 2rem;
		line-height: 93%;
		color: #fff;
		margin-top: 7.5rem;

		@media (max-width: 991.98px) {
			margin-top: 4rem;
			font-size: 1.8rem;
			text-align: center;
		}

		ul {
			display: flex;
			align-items: flex-end;
			justify-content: space-between;

			@media (max-width: 991.98px) {
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}

			li {
				@media (min-width: 991.98px) {
					flex: 1 1 33.3333%;

					&:first-child {
						a {
							align-items: flex-start;
							text-align: left;
						}
					}

					&:last-child {
						a {
							align-items: flex-end;
							text-align: right;
						}
					}
				}

				@media (max-width: 991.98px) {
					&:nth-child(1) {
						order: 2;
						margin-bottom: 1.3rem;
					}
					&:nth-child(2) {
						order: 1;
						margin-bottom: 5.3rem;
					}
					&:nth-child(3) {
						order: 3;
					}
				}

				a {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;

					img {
						margin-top: 2.2rem;
						max-width: 12rem;
					}
				}
			}
		}
	}
}
</style>
